import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TemperatureReadings_ds_temperature_readings_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number, orderId?: number }): 
  Promise<{ result: { Id?: number, DateCaptured?: string, Employee?: string, LicensePlateId?: number, LoadContainerId?: number, Notes?: string, ReadingPointId?: number, ReadingTypeId?: number, ShipmentId?: number, ShipmentLineId?: number, Temperature1?: number, Temperature2?: number, Temperature3?: number, LicensePlate?: { LookupCode?: string }, LoadContainer?: { LookupCode?: string }, ReadingPoint?: { Name?: string }, ReadingType?: { Name?: string }, Shipment?: { LookupCode?: string, OrderLookups?: { OrderId?: number }[] }, ShipmentLine?: { LineNumber?: number }, Temperature1MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature2MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature3MeasurementUnit?: { Name?: string, Short_name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_temperature_readings_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number, orderId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DateCaptured?: string, Employee?: string, LicensePlateId?: number, LoadContainerId?: number, Notes?: string, ReadingPointId?: number, ReadingTypeId?: number, ShipmentId?: number, ShipmentLineId?: number, Temperature1?: number, Temperature2?: number, Temperature3?: number, LicensePlate?: { LookupCode?: string }, LoadContainer?: { LookupCode?: string }, ReadingPoint?: { Name?: string }, ReadingType?: { Name?: string }, Shipment?: { LookupCode?: string, OrderLookups?: { OrderId?: number }[] }, ShipmentLine?: { LineNumber?: number }, Temperature1MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature2MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature3MeasurementUnit?: { Name?: string, Short_name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_temperature_readings_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number, orderId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, DateCaptured?: string, Employee?: string, LicensePlateId?: number, LoadContainerId?: number, Notes?: string, ReadingPointId?: number, ReadingTypeId?: number, ShipmentId?: number, ShipmentLineId?: number, Temperature1?: number, Temperature2?: number, Temperature3?: number, LicensePlate?: { LookupCode?: string }, LoadContainer?: { LookupCode?: string }, ReadingPoint?: { Name?: string }, ReadingType?: { Name?: string }, Shipment?: { LookupCode?: string, OrderLookups?: { OrderId?: number }[] }, ShipmentLine?: { LineNumber?: number }, Temperature1MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature2MeasurementUnit?: { Name?: string, Short_name?: string }, Temperature3MeasurementUnit?: { Name?: string, Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_temperature_readings_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentId?: number, shipmentLineId?: number, licensePlateId?: number, loadContainerId?: number, orderId?: number    }) {
      return false;
    }
}
